<template>
  <button
    :id="id"
    type="button"
    class="cs-button"
    :class="`cs-button__${buttonType}`"
    :disabled="disabled"
    @click="emit('click', $event)"
  >
    <div class="icon">
      <slot name="icon" />
    </div>
    <div class="text">
      <slot />
    </div>
  </button>
</template>

<script setup lang="ts">
import { csButtonTypes } from '~/helpers/csButtonUtils'

export type buttonType = typeof csButtonTypes[number];

defineProps({
  id: { type: String, default: null },
  buttonType: { type: String as () => buttonType, default: 'primary' },
  disabled: { type: Boolean, default: false }
})

const emit = defineEmits(['click'])
</script>

<style scoped lang="sass">
button
  background-color: transparent
  border: none
  cursor: pointer
  outline: none
  padding: 0
  appearance: none

button.cs-button
  display: flex
  align-items: center
  white-space: nowrap
  cursor: pointer
  text-align: center
  font-weight: bold
  font-size: 18px
  height: 42px
  padding: 0 15px
  border-radius: 31px
  box-sizing: border-box
  border: 2px solid
  line-height: 1
  &:disabled
    cursor: not-allowed
    .icon
      opacity: 0.5
  &:hover
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2)
    &:disabled
      box-shadow: none
  > .icon
    width: 20px
    height: 20px
    display: flex
    align-items: center
    margin-right: 8px
    > :deep(img)
      width: 20px
      height: 20px
  > .text
    display: flex
    align-items: center
    padding-top: 1px
    height: 18px
    white-space: nowrap
  &__primary
    border-color: #f4da40
    background-color: #f4da40
    color: #c39143
    &:disabled
      border-color: #f7e579
      background-color: #f7e579
      color: #D9B34C
  &__secondary
    border-color: #c39143
    background-color: #c39143
    color: #fff
    &:disabled
      border-color: #d5b27b
      background-color: #d5b27b
  &__tertiary
    border-color: #c39143
    background-color: #fff
    color: #c39143
    &:disabled
      border-color: #e1c8a1
      color: #e1c8a1
  &__negative
    border-color: #bbb
    background-color: #fff
    color: #888
    &:disabled
      border-color: #ddd
      color: #c3c3c3
  &__danger
    border-color: #dd5555
    background-color: #dd5555
    color: #fff
    &:disabled
      border-color: #e78888
      background-color: #e78888
</style>
